import { Header } from "@/types/VDataTable";
export const headers: Header[] = [
  {
    text: "User Name",
    type: "string",
    align: "left",
    value: "userName",
    class: "userName",
    sortable: true,
  },
  {
    text: "Role",
    type: "string",
    align: "left",
    value: "role",
    sortable: true,
    class: "role",
    width: "120px",
  },
  {
    text: "Email",
    type: "string",
    align: "left",
    value: "email",
    sortable: true,
    class: "email",
    width: "200px",
  },
  {
    text: "API Key",
    type: "indicator",
    align: "left",
    value: "apiKey",
    sortable: false,
    class: "apiKey",
    width: "95px",
  },
  {
    text: "Last Activity Date",
    type: "string",
    align: "left",
    value: "lastActivityDate",
    sortable: true,
    class: "lastActivityDate",
    width: "200px",
  },
  {
    text: "Actions",
    type: "actions",
    align: "left",
    value: "actions",
    sortable: false,
    class: "actions",
    width: "220px",
  },
];
